import React from "react";

import withSessionHandling, {
  type SessionHandlerProps,
} from "@/context/auth/withSessionHandling";
import { useRouterSearchParams } from "@/hooks/router";
import ProfileScreen from "@/screens/Profile/ProfileScreen";

function Page(props: SessionHandlerProps): React.JSX.Element {
  const username = useRouterSearchParams("username");
  return <ProfileScreen {...props} username={username} />;
}

export default withSessionHandling(Page);
